<!-- <div class="row">
  <div class="col-12">

    @for (q of data; track q.id) {

      <div (click)="toggle(q)" class="boder_bottom">

        <h4 class="padding_top_bottom position-relative">
          {{ q.title }}

          <img
            src="assets/img/home/expand_more_black_24dp.webp"
            class="{{ q.t === 'true' ? 'dropdown_icon_up' : 'dropdown_icon_down' }}"
            width="24"
            height="24"
            alt=""
          />
        </h4>

        @if (q.t === 'true') {
          <p>{{ q.content }}</p>
        }

      </div>

    }

  </div>
</div> -->


<div class="row">

  <!-- <h2>Answers to common questions about group therapy<span>.</span></h2> -->

  <div class="faq-panel col-lg-12">

    <article class="faq-item" *ngFor="let faq of data">

      <button type="button" (click)="toggleFaq(faq)">
        <span>
          {{ faq.title }}
        </span>

        <fa-icon [icon]="faq.open ? faChevronUp : faChevronDown">
        </fa-icon>
      </button>

      <div class="faq-content" *ngIf="faq.open" @faqAnimation>
        <p [innerHTML]="faq.content"></p>

        <ul *ngIf="faq.points?.length">
          <li *ngFor="let point of faq.points">
            {{ point }}
          </li>
        </ul>

        <p [innerHTML]="faq.contentTwo"></p>
      </div>
    </article>

  </div>
</div>